import React, { useState } from "react";
import MuiStepper from "../components/stepper/MuiSteper";
import Submit from "../pages/submit/Submit";
import ClinicInfo from "./ClinicInfo";
import PatientInfo2 from "./PatientInfo2";
import SimpleCartReview from "./SimpleCartReview";
import axios from "axios";
import Config from "../common/Config";
import MultipleLinerSelection from "./MultipleLinerSelection";
import AccountNumberPage from "./AccountNumberPage";

const LinerBundle = () => {
  const [activeInnerStep, setActiveInnerStep] = useState(0);

  const [activeOuterStep, setActiveOuterStep] = useState(0);
  const [open, setOpen] = useState(false);
  const [showSubmit, setShowSubmit] = useState(true);
  const [cart, setCart] = useState(Array(0));
  const [tempCart, setTempCart] = useState(Array(0));
  const [init, setInit] = useState(true);

  const formTypeId = 14;

  const loadCart = () => {
    setTempCart([]);
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    axios.get(
      Config.baseApiUrl + "cart/" + formTypeId,
      config
    ).then(response => {
      setCart(response.data);
    }).catch(error =>{
      console.log(error)
    });
  }

  const joinedCart = () => {
    let uniqueMainCart = cart.filter(c => !tempCart.some(t => t.sourceId?.toLowerCase() === c.sourceId?.toLowerCase() || t.name === c.name));

    return uniqueMainCart.concat(tempCart);
  }

  const handleNext = () => {
    loadCart();
    if (activeOuterStep === formData?.length - 1) {
      return;
    } else {
      setActiveOuterStep(activeOuterStep + 1);
      setActiveInnerStep(0);
    }
  };
  const handleBack = () => {
    loadCart();
    if (activeOuterStep === 0) {
      return;
    } else {
      setActiveOuterStep(activeOuterStep - 1);
    }
  };

  const handleClearBack = () => {
    setActiveOuterStep(0);
    setActiveInnerStep(0);    
  };  

  const handleClickOpen = (name) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setShowSubmit(true);
  };

  const formData = [

    {
      id: 4,
      name: "Liners",
      innerSteps: [],
      formContent: (
        <MultipleLinerSelection
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          setTempCart={setTempCart}
        />
      ),
    },

    {
      id: 6,
      name: "Customer information",
      innerSteps: [],
      formContent: (
        <ClinicInfo
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
        />
      ),
    },

    {
      id: 7,
      name: "Shipping Information",
      innerSteps: [],
      formContent: (
        <PatientInfo2
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
        />
      ),
    },

    {
      id: 8,
      name: "Order Review",
      innerSteps: [],
      formContent: (
        <SimpleCartReview
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          formName="Liners"
        />
      ),
    },

    {
      id: 9,
      name: "Submit",
      innerSteps: [],
      formContent: <Submit />,
    },
  ];

  if(localStorage.getItem("internalAccount")) {
    formData.unshift({
      id: 0,
      name:"Account Number",
      formContent: (
        <AccountNumberPage 
          setActiveInnerStep={setActiveInnerStep}
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
        />
      )
    })
  }

  const totalIds = formData.reduce((count) => {
    return count + 1;
  }, 0);


  if(init) {
    loadCart();
    setInit(false);
  }

  return (
    <>
      <div style={{ display: "flex", width: "100%" }}>
        <MuiStepper
          data={formData}
          innerStep={activeInnerStep}
          setInnerStep={setActiveInnerStep}
          setActiveOuterStep={setActiveOuterStep}
          activeOuterStep={activeOuterStep}
          formName="Liners"
          totalSteps={totalIds}
          cart={joinedCart()}
        />
      </div>
    </>
  );
};

export default LinerBundle;
